import React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
//import Logo from './Logo';
import { useMediaQuery } from '@material-ui/core';
import MyUserMenu from './user/UserMenu';


/*
const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

const useStyles = isSmall ? makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontSize: 8
    },
    spacer: {
        flex: 1,
    },
}):
makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontSize: 12
    },
    spacer: {
        flex: 1,
    },
})
;
*/

//red => f50057,   9F90D8

const MyAppBar = props => {
    
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const useStyles = makeStyles({
        title: {
            flex: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            fontSize: isSmall ? 12:18
        },
        spacer: {
            flex: 1,
        },
    });
    const classes = useStyles();

    return (
        <AppBar {...props}  style={{ background: '#5e35b1' }} userMenu={<MyUserMenu />}>
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            />
            <span className={classes.spacer} />
        </AppBar>
    );
};

export default MyAppBar;